import React from "react";
import { DisplayBanner } from "../../banner/bannerSlice";
import { BannerComponentId } from "../../banner/bannerComponentId";

const TROUBLE_TICKET_URL =
  "https://issues.amazon.com/issues/create?template=e48fc85f-4ee9-47da-a3e1-e6ee8eabd320";

const troubleTicketAnchorComponent: JSX.Element = (
  <span>
    If the problem continues, you may submit a trouble ticket{" "}
    <a href={TROUBLE_TICKET_URL} rel="noopener noreferrer" target="_blank">
      here
    </a>
    .
  </span>
);

export const teamFirstFailureBanner = (
  action: string,
  actioned: string
): DisplayBanner => ({
  type: "error",
  header: `Failed to ${action} team`,
  content: `The team couldn't be ${actioned} because of an issue with the server. Retrying your request might resolve the issue.`,
  dissmissible: true,
});

export const teamAfterFirstFailureBanner = (
  action: string,
  componentId: BannerComponentId
): DisplayBanner => ({
  type: "error",
  header: `Failed to ${action} team`,
  dissmissible: true,
  componentId,
});

export const teamAfterFirstFailureBannerContent = (
  content: string
): JSX.Element => (
  <div>
    The team couldn&apos;t be {content} because of an issue with the server.{" "}
    {troubleTicketAnchorComponent}
  </div>
);

export const changesFirstFailureBanner: DisplayBanner = {
  type: "error",
  header: `Failed to save changes`,
  content:
    "Your changes couldn't be saved because of an issue with the server. Retrying your request might resolve the issue.",
  dissmissible: true,
};

export const changesAfterFirstFailureBanner: DisplayBanner = {
  type: "error",
  header: `Failed to save changes`,
  dissmissible: true,
  componentId: BannerComponentId.ChangesAfterFirstFailure,
};

export const changesAfterFirstFailureBannerContent: JSX.Element = (
  <div>
    Your changes couldn&apos;t be saved because of an issue with the server.{" "}
    {troubleTicketAnchorComponent}
  </div>
);
